<template>
  <div class="google-pay-method">
    <!-- webstore  gid 为 28 的时候不展示 google pay -->
    <div class="method" :class="{ noClick: loadingShow }" @click="handleGooglePay" v-if="price">
      <div class="methods">
        <div class="method-img">
          <img v-if="isIOS()" src="@/assets/packageAssets/common/apple_pay.png" alt="" />
          <img v-else src="@/assets/packageAssets/common/google.png" alt="" />
        </div>
        <div class="line"></div>
        <div class="method-name">
          <span>{{ isIOS() ? 'Apple Pay' : 'Google Pay' }}</span>
          <div class="rate">
            <div class="pay-price">
              <i>{{ currency }}</i>
              <span>{{ price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Client from '@/assets/scripts/client'

export default {
  props: {
    loadingShow: {},
    price: {},
    currency: {}
  },
  data() {
    return {
      flag: false
    }
  },
  created() {},
  methods: {
    // 调谷歌的时候需要客户端提供方法
    handleGooglePay() {
      // 这是echo的 注意一下 方法名和vava的不一样
      this.$emit('handleAppleAndGooglePay')
    },

    // 判断设备  直接用客户端传的
    isIOS() {
      const appInfo = Client.getAppInfo()
      // deviceType  0 安卓 1 IOS
      return appInfo.deviceType == 0 ? false : true
    }
  }
}
</script>

<style lang="less" scoped>
.google-pay-method {
  .method {
    width: 100%;
  }
  .methods {
    display: flex;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 16px 0 8px;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;

    .method-img {
      display: flex;
      justify-content: center;
      > img {
        height: 32px;
        object-fit: contain;
      }
    }
    .line {
      height: 20px;
      margin: 0 5px;
      border-right: 1px solid #d8d8d8;
    }
    .method-name {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      line-height: 17px;
      font-family: Outfit;
      font-weight: 500;
      font-size: 14px;
      color: #222222;

      .rate {
        display: flex;
        align-items: center;
        .pay-price {
          position: relative;
          padding: 3px 10px;
          line-height: 22px;
          border-radius: 6px;
          background: #f9f4ed;
          color: #ffd786;
          font-family: Outfit;
          display: flex;
          align-items: center;
          > i,
          > span {
            color: #ff7f2d;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Outfit;
            font-style: normal;
            font-weight: 500;
          }
          > i {
            color: #ff7f2d;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Outfit;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
          }
          > span {
            font-size: 14px;
            margin-left: 2px;
          }
        }
        .pay-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .actTextColor {
          opacity: 0.1;
        }
      }
    }
  }
  .noClick {
    pointer-events: none;
  }
}
</style>
